import EndPoints from "../EndPoints";
import axios from "./axiosFileUpload";

// Upload Files Section
export const uploadFiles = async (payload) => {
  try {
    return await axios.post(EndPoints.uploadFiles, payload);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const uploadResume = async (payload) => {
  try {
    return await axios.post(EndPoints.uploadResume, payload);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const uploadImages = async (payload) => {
  try {
    return await axios.post(EndPoints.uploadImages, payload);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const uploadImagesformbuilder = async (payload) => {
  try {
    return await axios.post(EndPoints.uploadImagesformbuilder, payload);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const uploadFilecontact = async (payload) => {
  try {
    return await axios.post(EndPoints.uploadFilecontact, payload);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const getImagelist = async (payload) => {
  try {
    return await axios.post(EndPoints.getImagelist, payload);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const deleteResume = async (payload) => {
  try {
    return await axios.post(EndPoints.deleteResume, payload);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const showResume = async (payload) => {
  try {
    return await axios.post(EndPoints.showResume, payload);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

// multipart/form-data
